import Modal from '@Components/Shared/Modals/Modal';
import { List, ListItem, ListItemText, Typography, Divider } from '@mui/material';

const EmployeeKeywordSearchParamsModal = (props) => {
    const {
        toggleEmployeeModal,
        KeywordSearchParamsDetected
    } = props;

    return (
        <Modal onEscapeKeyClose={toggleEmployeeModal}>
            <Modal.Header onClose={toggleEmployeeModal}>
                <Modal.Title>
                    Employee Only - Keywords Detection
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {KeywordSearchParamsDetected ? (
                    <List>
                        {Object.entries(KeywordSearchParamsDetected).map(([key, value], index) => (
                            <React.Fragment key={key}>
                                <ListItem>
                                    <ListItemText
                                        primary={
                                            <Typography variant="subtitle1" fontWeight="bold">
                                                {key}
                                            </Typography>
                                        }
                                        secondary={
                                            <Typography variant="body2" color="textSecondary">
                                                {value.toString()}
                                            </Typography>
                                        }
                                    />
                                </ListItem>
                                {index < Object.entries(KeywordSearchParamsDetected).length - 1 && <Divider />}
                            </React.Fragment>
                        ))}
                    </List>
                ) : (
                    <Typography variant="body1" color="textSecondary">
                        No keyword search parameters detected.
                    </Typography>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default EmployeeKeywordSearchParamsModal;